// @flow

import type { PendingIncomingPayment, OpenedIncomingPayment } from './types';

export function getUpiIntentAppNamesInOpenedPayment(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const upiAppNames = incomingPayment['upi']['app_names'];
  if(!upiAppNames){
    throw new Error('No App Names in incoming payment');
  }
  return upiAppNames;
}

export function getUpiIntentAppLinksInPendingPayment(incomingPayment: PendingIncomingPayment): ImmutableArray<string> {
  const upiAppLinks = incomingPayment['upi']['app_links'];
  if(!upiAppLinks){
    throw new Error('No App Links in incoming payment');
  }
  return upiAppLinks;
}
